var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useDrag } from 'react-dnd';
import { ItemTypes } from './types';
const UserBox = ({ name, id }) => {
    _react_refresh_temp_2();
    const [{ isDragging }, drag] = useDrag(() => ({
        type: ItemTypes.USER,
        item: { name, id },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
            handlerId: monitor.getHandlerId(),
        }),
    }));
    const opacity = isDragging ? 0.4 : 1;
    return (_jsx("div", { ref: drag, style: { opacity }, className: "userBox text-sm sm:text-base text-black dark:text-darkText bg-white dark:bg-darkSecondary2 border-b border-solid border-black/80 dark:border-darkText/90 w-full px-2 py-1 cursor-move", children: name }));
};
_react_refresh_temp_1 = UserBox;
$RefreshReg$(_react_refresh_temp_1, "UserBox");
_react_refresh_temp_2(UserBox, "wuumsFp4qAni9XRJfRhQAZjuD/k=", false, () => [useDrag]);
export default UserBox;
